if (!customElements.get('daily-wellness-routine')) {
  customElements.define(
    'daily-wellness-routine',
    class DailyWellnessRoutine extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('[data-dwr-add-to-cart]');
        if (this.button) {
          this.button.addEventListener('click', this.handleAddToCart.bind(this));
        }
      }

      async handleAddToCart(event) {
        event.preventDefault();

        const variantIds = (this.button.dataset.variantIds || '')
          .split(',')
          .map((id) => id.trim())
          .filter(Boolean);

        if (!variantIds.length) return;

        this.button.setAttribute('disabled', 'true');
        this.button.classList.add('loading');
        const spinner = this.button.querySelector('.loading-overlay__spinner');
        spinner?.classList.remove('hidden');

        const items = variantIds.map((id) => ({
          id: parseInt(id, 10),
          quantity: 1,
        }));

        const cart =
          document.querySelector('cart-drawer') ||
          document.querySelector('cart-notification');

        const payload = { items };

        if (cart) {
          payload.sections = cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
          cart.setActiveElement(this.button);
        }

        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          });

          const data = await response.json();

          if (data.status) {
            console.error(data.description || data.message);
            return;
          }

          if (cart) {
            cart.renderContents(data);
            if (cart.classList.contains('is-empty')) {
              cart.classList.remove('is-empty');
            }
          } else {
            window.location = window.routes.cart_url;
          }
        } catch (error) {
          console.error(error);
        } finally {
          this.button.removeAttribute('disabled');
          this.button.classList.remove('loading');
          spinner?.classList.add('hidden');
        }
      }
    }
  );
}
